import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 10.25v-3.5m0 7.5v-1.5M8.192 3.767c.798-1.356 2.818-1.356 3.616 0l6.167 10.476c.789 1.341-.213 3.007-1.808 3.007H3.833c-1.595 0-2.597-1.666-1.808-3.007L8.192 3.767Z"
	})]
});
const ForwardRef = forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
